import { useContext, useEffect, useState } from "react";
import { createPortal } from "react-dom";
import Navbar from "react-bootstrap/Navbar";
import Nav from "react-bootstrap/Nav";
import Container from "react-bootstrap/Container";
import logo from "../Assets/logo.png";
import { Link, useNavigate } from "react-router-dom";
import { MyContext } from "../Context/MyContext";
import { useMediaQuery } from "@mui/material";
import ThemeToggle from "../components/ThemeToggle/ThemeToggle";
import site from "../data/site";
import { requestBookCall } from "../lib/bookCall";

function NavBar() {
  const [expand, updateExpanded] = useState(false);
  const [navColour, updateNavbar] = useState(false);
  const isMobile = useMediaQuery("(max-width:767px)");
  const navigate = useNavigate();
  const { processRef } = useContext(MyContext);

  useEffect(() => {
    const scrollHandler = () => {
      updateNavbar(window.scrollY >= 20);
    };
    window.addEventListener("scroll", scrollHandler);
    return () => window.removeEventListener("scroll", scrollHandler);
  }, []);

  useEffect(() => {
    if (!isMobile) {
      updateExpanded(false);
    }
  }, [isMobile]);

  useEffect(() => {
    document.body.style.overflow = expand && isMobile ? "hidden" : "";
    return () => {
      document.body.style.overflow = "";
    };
  }, [expand, isMobile]);

  const close = () => updateExpanded(false);

  const goProcess = () => {
    close();
    if (window.location.pathname === "/") {
      window.location.hash = "process";
      processRef?.current?.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  const drawer =
    isMobile &&
    createPortal(
      <div className={`mobileDrawer ${expand ? "isOpen" : ""}`} aria-hidden={!expand}>
        <div className="mobileDrawerGlow" />
        <nav className="mobileDrawerNav" aria-label="Mobile">
          <Link className="mobileDrawerLink" style={{ "--i": 0 }} to="/services" onClick={close}>
            <span className="mobileDrawerIndex">01</span>
            <span className="mobileDrawerLabel">Services</span>
          </Link>
          <div className="mobileDrawerSub">
            {site.services.map((service) => (
              <Link key={service.slug} to={`/services/${service.slug}`} onClick={close}>
                {service.title}
              </Link>
            ))}
          </div>
          <Link
            className="mobileDrawerLink"
            style={{ "--i": 1 }}
            to="/#process"
            onClick={goProcess}
          >
            <span className="mobileDrawerIndex">02</span>
            <span className="mobileDrawerLabel">Process</span>
          </Link>
          <Link className="mobileDrawerLink" style={{ "--i": 2 }} to="/about" onClick={close}>
            <span className="mobileDrawerIndex">03</span>
            <span className="mobileDrawerLabel">About</span>
          </Link>
        </nav>
        <div className="mobileDrawerFoot">
          <button
            type="button"
            className="buttonHome mobileDrawerCta"
            onClick={() => {
              close();
              requestBookCall(navigate);
            }}
          >
            Book a Call
          </button>
          <a className="mobileDrawerPhone" href={`tel:${site.phone}`}>
            {site.phoneDisplay}
          </a>
          <a className="mobileDrawerEmail" href={`mailto:${site.email}`}>
            {site.email}
          </a>
        </div>
      </div>,
      document.body
    );

  return (
    <>
      <Navbar
        expanded={isMobile ? false : expand}
        fixed="top"
        expand="md"
        className={`${navColour ? "sticky" : "navbar"} ${expand ? "menuOpen" : ""}`}
      >
        <Container>
          <Navbar.Brand as={Link} to="/" className="d-flex" onClick={close} aria-label="DigitaliNation home">
            <img src={logo} className="img-fluid logo" alt="" />
            <span className="brandMark">DigitaliNation</span>
          </Navbar.Brand>
          <div className="d-flex align-items-center">
            {isMobile ? <ThemeToggle /> : null}
            <Navbar.Toggle
              aria-controls="responsive-navbar-nav"
              aria-expanded={expand}
              className={expand ? "is-open" : ""}
              onClick={() => {
                updateExpanded((open) => !open);
              }}
            >
              <span></span>
              <span></span>
              <span></span>
            </Navbar.Toggle>
          </div>
          <Navbar.Collapse id="responsive-navbar-nav">
            <Nav className="ms-auto" defaultActiveKey="/">
              <Nav.Item className="navServices">
                <Nav.Link as={Link} to="/services">
                  Services
                </Nav.Link>
                <div className="navServicesMenu">
                  {site.services.map((service) => (
                    <Link key={service.slug} to={`/services/${service.slug}`}>
                      {service.title}
                    </Link>
                  ))}
                </div>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link as={Link} to="/#process" onClick={goProcess}>
                  Process
                </Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link as={Link} to="/about">
                  About
                </Nav.Link>
              </Nav.Item>
              {!isMobile ? (
                <Nav.Item className="d-flex align-items-center">
                  <ThemeToggle />
                </Nav.Item>
              ) : null}
              <Nav.Item className="fork-btn">
                <button
                  type="button"
                  className="buttonHome"
                  style={{
                    marginTop: "0px",
                    padding: "0.55rem 1rem",
                    minWidth: "auto",
                    width: isMobile ? "100%" : "auto",
                    marginLeft: isMobile ? "0px" : "10px",
                  }}
                  onClick={() => requestBookCall(navigate)}
                >
                  Book a Call
                </button>
              </Nav.Item>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
      {drawer}
    </>
  );
}

export default NavBar;
